import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingScreen from './LoadingScreen';

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { currentUser, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!currentUser) {
    const search = location.search; // e.g. "?table=5"

    // Check if we are on an admin route

    const path = location.pathname;
    const adminPaths = ['/admin', '/analytics', '/kitchen', '/ingredients', '/branches', '/homepage'];
    const isAdminRoute = adminPaths.some(p => path.includes(p));

    const lastSlashIdx = path.lastIndexOf('/');
    const dir = lastSlashIdx > 0 ? path.substring(0, lastSlashIdx) : '';

    if (isAdminRoute) {
      console.log('[ProtectedRoute] 🛑 Admin route without auth - Redirecting to Login');

      // Maintain current origin to support subdomain-based login
      const currentOrigin = window.location.origin;

      // Perform hard redirect on the SAME site
      window.location.href = `${currentOrigin}${dir}/signup?mode=login`;
      return null;
    }

    // For non-admin (customer) routes, allow public access
    const isCustomerRoute = path.toLowerCase().includes('/customer');
    if (isCustomerRoute) {
      const searchParams = new URLSearchParams(search);
      const table = searchParams.get('table');
      const companyId = searchParams.get('companyId');
      if (table && companyId) {
        try {
          localStorage.setItem('scanned_qr_context', JSON.stringify({
            table,
            companyId,
            branch_id: searchParams.get('branch_id'),
            timestamp: Date.now()
          }));
        } catch (e) {}
      }
      return children;
    }

    const redirectPath = `/signup?mode=login${search}`;
    return <Navigate to={redirectPath} replace />;
  }

  // If a specific role is required, check if user has that role
  // 'customer' and 'admin' are treated as privileged roles
  if (requiredRole && currentUser.role !== requiredRole && currentUser.role !== 'customer' && currentUser.role !== 'admin') {
    // Redirect based on user role
    if (currentUser.role === 'user') {
      return <Navigate to="/customer.html" replace />;
    } else {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;